import { getAppShareURL } from "@/libs/api.js";
import {  getCookie } from "@/libs/common.js";
export const pubMethods = {
	// data() {
	// 	return {
	// 		cityLocation: null,
	// 		lat: 0,
	// 		lng: 0,
	// 		latng: 0,
	// 		adcode: "",
	// 		currentCity: "",
	// 		currentCityDetail: "",
	// 		cityByStorage: this.getStorage("home", "home.CURRENT_CITY").currentCity,
	// 		locationByStorage: this.getStorage("home", "home.CURRENT_CITY").location,
	// 		adCodeByStorage: this.getStorage("home", "home.AD_CODE"),
	// 		addrByStorage: this.getStorage("home", "home.CURRENT_CITY").addr,
	// 		positionTime: "",
	// 		canGetIndex: false,
	// 	};
	// },
	methods: {
		/**
		 * 获取缓存数据
		 * key 模块
		 * val 模块对应值
		 */
		getStorage(key, val) {
			let item = JSON.parse(localStorage.getItem("ylxdsq"));
			if (item) {
				return item[key][val];
			} else {
				return;
			}
		},
		// 当前地址并添加分享人id
		getCurrentLink(link,freshActType) {
			// 去除当前页所有参数
			let currentLocation;
			if (~link.indexOf("?")) {
				currentLocation = link.slice(0, link.indexOf("?"));
			} else {
				currentLocation = link;
			}
			let store_id = this.getStorage("user", "user.STORE_ID");
			let clientType = "";
			if (this.$browser().miniprogram) {
				clientType = "miniwx_ylxdsq";
			} else if (this.$browser().ylxdsq || this.$browser().yzg) {
				clientType = "app_ylxdsq";
			} else if(this.$browser().ule){
				clientType = "app_ylw";
			}else{
				clientType = "wap_ylxdsq";
			}
			console.log(currentLocation);
			// 添加分享人id
			return (currentLocation = `${currentLocation}?storeid=${store_id}&shareId=${this.shareId}&client_type=${clientType}&appName=ylxdsq&adid=ylxdfx_community&freshActType=${freshActType}`);
		},
		// 获取分享参数
		objectassign(target) {
			for (var i = 1; i < arguments.length; i++) {
				var source = arguments[i];
				for (var key in source) {
					if (Object.prototype.hasOwnProperty.call(source, key)) {
						target[key] = source[key];
					}
				}
			}
			return target;
		},
		// 统一分享
		goodsShare(title, desc, link, img, listingId, price, mkPrice,freshActType,cardData) {
			console.log('统一分享================')
			if(this.$browser().yzg){
				console.log('邮掌柜单独')
				getAppShareURL(
					{
						clientCallType: "H5",
						data: JSON.stringify({
							shareChannel: "11",
							shareFrom: "0",
							listInfo: [
								{
									listId: listingId || this.listingId,
									sharePrice: price || this.price || 0,
									marketPrice: mkPrice || this.mkPrice || 0,
									freshActType:freshActType || '',
									shareFrom: "0",
								},
							],
						}),
					},
					"jsoncallback"
				).then(res=>{
					if (res.returnCode === "0000") {
						this.shareId = res.data.shareId;
					} else {
						this.shareId = "";
					}
					link = this.getCurrentLink(link,freshActType);
					console.log(link, "sharelink");
					this.shareApp(res.data, title, desc, img, listingId, price, mkPrice,freshActType,cardData||{});
				})
			}else{
				getAppShareURL(
					{
						clientCallType: "H5",
						data: JSON.stringify({
							shareChannel: "1",
							shareFrom: "0",
							listInfo: [
								{
									listId: listingId || this.listingId,
									siteId: getCookie("siteId")||'',
									sharePrice: price || this.price || 0,
									marketPrice: mkPrice || this.mkPrice || 0,
									freshActType:freshActType || '',
									shareFrom: "0",
								},
							],
						}),
					},
					"jsoncallback"
				).then((res) => {
					if (res.returnCode === "0000") {
						this.shareId = res.data.shareId;
					} else {
						this.shareId = "";
					}
					link = this.getCurrentLink(link,freshActType);
					console.log(link, "sharelink");
					let ylyx_share_channel='';
					// 小程序分享
					if (this.$browser().miniprogram) {
						this.shareMiniprogram(title, desc, link, img, listingId, price, mkPrice,freshActType);
						ylyx_share_channel="小程序";
					}
					// 微信环境分享
					else if (this.$browser().wx) {
						this.shareWx(title, desc, link, img,freshActType);
						ylyx_share_channel="微信好友";
					}
					// 小店优鲜APP、邮掌柜小店APP分享
					else if (this.$browser().ylxdsq || this.$browser().yzgxd) {
						this.shareApp(res.data, title, desc, img, listingId, price, mkPrice,freshActType,cardData||{});
					} else {
						this.$toast("点击浏览器分享");
					}
					//神策埋点
					window.uleStatUtil && window.uleStatUtil.sendSensorTrack('ylyx_ShareResult', {
						ylyx_event_share_id: res.data.shareId,
						ylyx_event_sharer_id: this.$route.query.store_id || this.$route.query.storeid || this.getStorage("user", "user.STORE_ID") || "",
						ylyx_share_channel: ylyx_share_channel,
						ylyx_share_content_type: '商品',
						ylyx_share_content_name: title,
						item_id: listingId || this.listingId,
						ylyx_commodity_current_price: mkPrice,
						ylyx_commodity_original_price:price,
						ylyx_share_content_id: listingId || this.listingId,
					});
				});
			}
		},
		// 微信环境分享
		shareWx(title, desc, link, img,freshActType) {
			console.log(link, "shareWxsharelink");
			window.setWeiXinShare({
				title: title || location.title,
				desc,
				link,
				imgUrl: img,
				freshActType
			});
			this.showTip = true;
		},
		// 小程序分享
		shareMiniprogram(title, desc, link, img, listingId, price, mkPrice,freshActType) {
			let imgUrl = [img];
			// 图片统一处理
			imgUrl.forEach((item, index) => {
				imgUrl[index] = item.replace(/pic1.|pic2.|pic3.|pic4./, "pic");
				if (!~imgUrl[index].indexOf("http")) {
					imgUrl[index] = `https:${item}`;
				}
			});
			let data = {
				title,
				desc,
				link,
				imgUrl,
				listingId,
				price,
				mkPrice,
				freshActType
			};
			let miniprogramShareObj = encodeURIComponent(JSON.stringify(data));
			window.wx.miniProgram.navigateTo({
				url: `/pages/share/share?data=${miniprogramShareObj}`,
			});
			// window.wx.miniProgram.navigateTo({
			//     url: "/pages/share/share?target=" + encodeURIComponent(link) +
			//         `&title=${title}&imgUrl=${img}&listingId=${listingId}&price=${price}&mkPrice=${mkPrice}`
			// });
		},
		// APP分享
		shareApp(shareData, title, desc, img, listingId, price, mkPrice,freshActType,cardData) {
			let _index = Math.floor(Math.random() * shareData.sectionList.length);
			let data = {
				listName: title,
				listImage: [img],
				shareCommission: 0,
				shareTitle: shareData.sectionList[_index].attribute1.replace(/#salePrice#/, price).replace(/#listName#/, title),
				shareContent: shareData.sectionList[_index].attribute2.replace(/#salePrice#/, price).replace(/#listName#/, title),
				WXMiniProgram_pageUrl: shareData.shareUrl4 || shareData.shareUrl3,
				cardWXMiniProgram_Title: cardData.title,
				WXMiniProgram_image: img,
				WXMiniProgram_path: shareData.miniWxShareInfo && shareData.miniWxShareInfo.path,
				WXMiniProgram_OriginalId: shareData.miniWxShareInfo && shareData.miniWxShareInfo.originalId,
				canShareOkCallBack: true,
				ruleDescription: "",
				imageBanner: img,
				miniwx_qrcode_url:shareData?.miniwx_qrcode_url
			};
			let shareObj = this.objectassign({}, data, shareData, {
				listId: listingId,
				sharePrice: price,
				marketPrice: mkPrice,
				freshActType:freshActType,
				shareFrom: "0",
				isCreateShareWXMini:cardData.isCreateShareWXMini,
				label:cardData.label
			});
			if (this.$browser().ylxdsq) {
				shareObj.shareUrl = shareObj.shareUrl4 || shareObj.shareUrl3;
				shareObj.shareOptions = "1##3##4";
			} 
			else if (this.$browser().yzgxd) {
				//shareUrl4 是短链没法处理链接里的参数 
				shareObj.url = shareObj.url
					.replace(/ylxdfx_community/g, "yzgxdfx_merchant")
					.replace(/ylxdsq/g, "yzgxd")
					.replace(/ylxdfx/, "yzgxdfx");
				shareObj.shareUrl = shareObj.shareUrl3
					.replace(/ylxdfx_community/g, "yzgxdfx_merchant")
					.replace(/ylxdsq/g, "yzgxd")
					.replace(/ylxdfx/, "yzgxdfx");
				shareObj.shareOptionsIndex = "0##1";
				shareObj.shareOptions = "0##1";
			}
			else if(this.$browser().yzg){
				shareObj.shareOptions = "4##1";
				shareObj.url = shareObj.url
				shareObj.shareUrl = shareObj.shareUrl3
			}
			console.log('shareObjshareObjshareObj====',shareObj)
			if (window.dsBridge) {
				window.dsBridge.call("generalAction", {
					type: "2",
					ios_action: JSON.stringify(shareObj),
					android_action: JSON.stringify(shareObj),
					maxversion: "999&999",
					needlogin: "false",
				});
			} else {
				window.location.href =
					"uleMobile://uleShare_" +
					encodeURI(shareObj.shareTitle) +
					"##" +
					encodeURI(shareObj.shareContent) +
					"##" +
					shareObj.listImage +
					"##" +
					shareObj.shareUrl +
					"##" +
					shareObj.shareContent;
			}
		},
		// 统一返回方法
		pageBack() {
			if ((this.$browser().ylxdsq || this.$browser().ulemax) && document.referrer) {
				//其他来源返回处理
				this.$router.go(-1);
			} else if (this.$browser().ylxdsq || this.$browser().ulemax) {
				if (window.history.length <= 1) {
					// 如果是小店社区APP
					if (navigator.userAgent.indexOf("Android") > -1) {
						location.href = "ulemobile://ulePopView";
					} else {
						location.href = "objc:ulemobile://ulePopView";
					}
					return false;
				} else {
					this.$router.go(-1);
				}
			} else if ((this.$browser().wx || this.$browser().miniProgram) && this.$route.query.shareId) {
				this.toNext("/");
			} else {
				this.$router.go(-1);
			}
		},
		// 页面跳转
		toNext(path, val = 0) {
			// this.$router.push("/pickup/pointAdd");
			let query = this.$route.query; // 当前地址上的参数
			let arr = Object.keys(query).length; // 判断是否有参数
			if (arguments.length === 2) {
				query = Object.assign(query, val);
			} else if (arguments.length === 1) {
				if (arr === 0) {
					this.$router.push(path).catch((err) => {
						console.log("all good");
					});
				} else {
					query = Object.assign(query, val);
				}
			}
			this.$router
				.push({
					path,
					query: query,
				})
				.catch((err) => {
					console.log("all good");
				});
			// if (arr === 0) {
			// 	this.$router.push(path);
			// } else {
			// 	if (arguments.length === 2) {
			// 		query = Object.assign(query, val);
			// 	}
			// 	this.$router.push({
			// 		path,
			// 		query: query,
			// 	});
			// }
		},
		// 复制文字
		copyText(text, callBack, fn) {
			this.$copyText(text).then(
				(e) => {
					console.log(e);
					if (arguments.length >= 2) {
						callBack();
					}
					if (arguments.length < 3) {
						this.$toast("复制成功");
					}
				},
				(e) => {
					console.log(e);
					if (arguments.length === 3) {
						fn();
					} else {
						this.$toast("复制失败");
					}
				}
			);
		},
	},
};